var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_1300)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1399_1300",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H32V32H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1399_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.28711 8.30912C6.30842 8.853 6.90136 9.32425 7.41823 10.164C8.65017 12.1623 9.77942 12.1977 11.0999 13.0216L15.1993 15.5779C15.9197 16.0262 16.5179 16.2175 16.9162 15.4681C17.3145 14.7187 16.9463 13.1615 16.0984 12.2828L13.8293 9.92656C13.3071 9.31181 13.6611 8.92744 14.5267 8.78212C16.8454 8.39412 17.3817 9.40044 18.4119 11.1702M22.7998 12.4458L20.3235 8.07706C18.9287 5.487 16.4011 5.60387 13.785 5.29212C10.8945 4.94662 10.6733 4.58881 8.01473 3.17506",
    stroke: "#131313",
    strokeWidth: 1.24787,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65572 8.25019L3.67353 9.32557C4.13372 9.57 4.70903 9.39288 4.95328 8.934L8.05791 3.08957C8.30216 2.63069 8.12697 2.05319 7.66672 1.81044L5.64891 0.73513C5.18872 0.49063 4.61341 0.666006 4.36916 1.12663L1.26453 6.97113C1.02028 7.42994 1.19553 8.00569 1.65572 8.25019Z",
    stroke: "#131313",
    strokeWidth: 1.24787,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08789 18.3237H30.8416V30.0304C30.8416 30.7691 30.2363 31.375 29.4981 31.375H10.4313C9.69327 31.375 9.08789 30.7691 9.08789 30.0304V18.3237Z",
    stroke: "#131313",
    strokeWidth: 1.24787,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9425 18.3242C16.1602 17.6617 15.6663 16.744 15.5194 15.7643M16.3531 12.5896C17.5727 11.0217 19.7746 10.5097 21.5871 11.4735C23.6138 12.5542 24.3837 15.0733 23.3058 17.1036C23.0509 17.5837 22.7146 17.9929 22.3252 18.3242",
    stroke: "#131313",
    strokeWidth: 1.24787,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.701 22.0273H30.8416M9.08789 22.0273H13.0935",
    stroke: "#131313",
    strokeWidth: 1.24787,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.998 28.2949H25.9316V25.1078H13.998V28.2949Z",
    stroke: "#131313",
    strokeWidth: 1.24787,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8987 22.0273H15.8963",
    stroke: "#131313",
    strokeWidth: 1.24787,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_1300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2);
export default __webpack_public_path__ + "static/media/a2.45e8ed7bb30392ea8ff7933b6e70ffa7.svg";
export { ForwardRef as ReactComponent };